import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//Utils
import { openExternalURL } from '../../../utils/functions';
//CSS
import './style.css';
//
export default function Promo(props){
    return(
        <section id={props.id} className="promo-section pt-5 pb-5">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={7} md={8}>
                        <div className="section-heading text-center mb-5">
                            {props.title.split(' \n ').map((line, i)=><h2 key={i}>{line}</h2>)}
                            {props.text.split(' \n ').map((line, i)=><p className="lead" key={i}>{line}</p>)}
                        </div>
                    </Col>
                </Row>
                <Row className="equal">
                    {props.promoList.map((item, i)=>
                        <Col lg={4} md={4} className="p-2" key={i}>
                            <div className="single-promo single-promo-hover single-promo-1 text-center white-bg p-5 h-100">
                                <div className="circle-icon mb-5">
                                    <span className="text-white"><FontAwesomeIcon icon={item.icon}/></span>
                                </div>
                                <h5>{item.name}</h5>
                                <h5 className="text-success">{item.price}</h5>
                                <p>{item.text}</p>
                                <Button onClick={()=>openExternalURL('lote_'+(i+1), 'Lote Selecionado.', item.link)} className={`btn solid-btn btn-block ${item.disabled?'disabled':''}`} disabled={item.disabled}>
                                    {item.disabled?'Indisponível':'Comprar'}
                                </Button>
                            </div>
                        </Col>
                    )}
                </Row>
            </Container>
        </section>
    );
}